"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
const jsonUtils_1 = require("benjibooks-shared/utils/jsonUtils");
const flatten_1 = __importDefault(require("lodash/flatten"));
const uniq_1 = __importDefault(require("lodash/uniq"));
const countryUtils = __importStar(require("../../utils/countryUtils"));
const ConfigResource_1 = require("./ConfigResource");
/**
 * Config that is read from a configuration file.
 */
class Config {
    constructor() {
        /** The tenant id. */
        this.tenantId = "";
        /** The short name of the tenant. */
        this.name = "";
        /** The full name of the tenant used in address block of booking/invoices. */
        this.fullName = "";
        /** The multi-line address visible on the booking/invoices. */
        this.address = "";
        this.zip = "";
        this.city = "";
        this.country = countryUtils.DEFAULT_COUNTRY_CODE;
        /** The IANA time zone name (see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones). */
        this.timeZone = "Europe/Zurich";
        /** The email address of the tenant. */
        this.email = "";
        /** The phone number of the tenant. */
        this.phone = "";
        /** The main website of the tenant. */
        this.website = "";
        /** The room overview website of the tenant. */
        this.overview = "";
        /** The filename for the logo image. */
        this.logo = "";
        this.defaultTaxRate = 8.1;
        this.taxNumber = "CHE-XXX.XXX.XXX";
        this.bank = { name: "", accountHolder: "", accountBic: "", accountIban: "" };
        this.paymentInfo = {
            bookingStatusProvisional: "Die Buchung ist noch provisorisch. Sie wird vom Team überprüft und bestätigt.",
            bookingStatusConfirmed: "Nach dem gebuchten Tag wirst du von uns per E-Mail eine Rechnung erhalten.",
            bookingStatusCancelled: "Die Buchung wurde annulliert. Du wirst von uns benachrichtigt, falls Annullationsgebühren anfallen.",
            invoiceStatusOpen: "Die Rechnung ist zahlbar innert 10 Tagen.",
            invoiceStatusPartial: "Die Rechnung ist zahlbar innert 10 Tagen.",
            invoiceStatusPaid: "Die Rechnung wurde vollständig bezahlt. Vielen Dank!",
            invoiceStatusZero: "Es gibt nichts zu bezahlen.",
            invoiceStatusVoid: "Die Rechnung wurde storniert. Es gibt nichts zu bezahlen.",
        };
        this.defaultResourceUnits = {
            singular: "Stunde",
            plural: "Stunden",
        };
        this.defaultAddonUnits = {
            singular: "Stück",
            plural: "Stück",
        };
        this.miscAddonType = "Verschiedenes";
        this.resources = [];
    }
    /** Returns the resource with the specified id or undefined if it does not exist. */
    getResourceById(resourceId) {
        return this.resources.find((resource) => resource.id === resourceId);
    }
    getVisibleResources() {
        return this.resources.filter((resource) => resource.visible);
    }
    /** Returns the visible resource with the specified id or undefined if it does not exist. */
    getVisibleResourceById(resourceId) {
        return this.getVisibleResources().find((resource) => resource.id === resourceId);
    }
    getAllAddonTypes({ includeHidden = false, includeMisc = false, } = {}) {
        const types = (0, uniq_1.default)((0, flatten_1.default)(this.resources.map((resource) => resource.getAddonTypes({ includeHidden, includeMisc })))).sort();
        return types;
    }
    /** Retruns the image by name of the current tenant. */
    getImageUrl(imageName) {
        return `/${this.tenantId}/${imageName}`;
    }
    /**
     * Constructs an object of this class from the specified JSON-compatible dictionary object.
     */
    static fromJSON(json) {
        const obj = new Config();
        Object.assign(obj, json);
        // Overwrite fields that need converting.
        if ((0, jsonUtils_1.isJSONObjectArray)(json.resources)) {
            obj.resources = json.resources.map((res) => ConfigResource_1.ConfigResource.fromJSON(res, obj));
        }
        else {
            throw new Error("Config does not contain valid `resources`.");
        }
        return obj;
    }
    /**
     * Converts this object to JSON-compatible dictionary object.
     * All fields from `this` will be in the returned object except the `undefined` values.
     */
    toJSON() {
        const json = (0, jsonUtils_1.toJSONWithFilters)(this, {
            filterUndefined: true,
        });
        // Overwrite fields that need converting.
        json.resources = this.resources.map((res) => res.toJSON());
        return json;
    }
}
exports.Config = Config;
